<div class="loading" *ngIf="!loaded"></div>
<div class="white" [formGroup]="gradeClassForm" *ngIf="loaded" [dir]="textDir">
    <div>
        <label class="form-title">1. {{'Add school classes' | translate}}</label>
        <label class="label-light">{{schoolDetails.name}}</label>
    </div>
     <div class="marT10 txt-hgt">  
         <label class="labeltxt" *ngIf="!nextClicked">{{'Please enter the classes that are' | translate}}</label>
        <label class="labeltxt" *ngIf="nextClicked" >{{'Is this correct' | translate}}</label>
    </div> 
   
     <div class="row marB10 marT15">
        <div class="md-4" ><label class="label-light-opa">{{'School grade' | translate}}</label></div>
        <div class="md-6 padL20" ><label class="label-light-opa">{{'Classes' | translate}}</label></div>
    </div>
    <div >
    <form id="addGradeClassForm" class="form-inline"  [formGroup]="gradeClassForm">
    
    

      <div formArrayName="gradeArray">

          <div *ngFor="let gradeClass of this.gradeClassForm.controls.gradeArray['controls'] |orderBy: ['controls.grade.value.year.number'] let i = index">
              <div class="row marB20" [formGroupName]="i">
                  <div class="md-4">
                      <label class="labeltxt">{{gradeClass.get('grade').value.name}}</label>
                      <input type="hidden" class="txt-wid" formControlName="grade" value="{{gradeClass.get('grade').value}}">
                  </div>
                  <div class="md-6 padL20" *ngIf="!nextClicked" >                      
                    <!--   <input type="text" class="form-control" placeholder="Start Typing" style="width:260px;" formControlName="classes"> -->
                           <input type="text" class="form-control txt-wid" placeholder="Ex. Green class, Red class" formControlName="classes">
                  </div>
                  <div class="md-6" >
                      <ng-container *ngIf="nextClicked">
                           <label class="labeltxt padL20">{{gradeClass.get('classes').value}}</label>          
                        </ng-container>
                </div>
                  <!--<span style="margin-right: 10%;color: #cc0000;" *ngIf="!grade.valid && grade.touched">Grade should not contain special chars</span>-->
                  <span style="margin-left: 44%;color: #cc0000;" *ngIf="!gradeClass.controls.classes.valid && gradeClass.controls.classes.touched">Each class should contain 3 chars only.</span>
              </div>
          </div>

      </div>
  </form>
</div>
</div>
